import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import React, { useRef, useState } from "react";
import ComprobantesDialogDetalle from "./ComprobantesDialogDetalle";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { usePresentacionContext } from "../context/presentacion.context";
import {
  MESSAGE_DIFERENCIA_IMPUESTOS_MF,
    MESSAGE_ERROR_PRESENTACION,
  MESSAGE_FAILED_ANULAR_PRESENTACCION,
  MESSAGE_SUCCESS_ANULAR_PRESENTACCION,
  MESSAGE_VALIDACION_IMPUESTOS,
} from "../utilities/messages.utilities";

import {
  anularPresentacion,
  presentarPresentacion,
} from "../services/presentaciones.services";
import { consultarFacturasPresentacion } from "../services/facturas.service";
import { validacionesPresentacion } from "../utilities/validaciones";
import { formatMoney } from "../../shared/utilitties/formatMoney";
import { presentacionPresentarRequest } from "../adapters/presentaciones.adapter";
//context
import { useGlobalContext } from "../../shared/context/global.context";
//css
import "./comprobantesDialog.css";
import { comprobantesProcess } from "../utilities/comprobantes";
import { useHistory, useLocation } from "react-router";
import { isCombustibleAfines } from "../utilities/utils";
import { ParametroDTO } from "../models/parametros.model";
import { PrivateRoutes } from "../../shared/models/routes";

const AccionesPresentaciones = () => {
  const { comercioSelecionado,userSessionModulo } = useGlobalContext();
  const {
    setShowDialogPresentar,
    presentacion,
    showDialogPresentar,
    setComprobantes,
    comprobantes,
    dataImpuestos,
    sumTSeleccionadas, 
    transaccionesSeleccionadas,
    presentacionEditable,
    setShowMask,
    selectedProductoComercio,detailsTxSeleccionadas,
    presentacionComercio,parametrosPresentacion,
    setSumImpuestosMF,sumImpuestosMF,totalImpuestosMF,
  } = usePresentacionContext();
  const history = useHistory();
  const toast = useRef<Toast>(null);
  const [showDialogAnular, setShowDialogAnular] = useState(false);
  const { state } = useLocation();
  const [spinnerPresentacion,setSpinnerPresentacion] = useState(false)

  const onClickPresentar = async () => {
    if(!isCombustibleAfines(selectedProductoComercio.grupoProductoId)){
      const difImpuestosMF = Number(totalImpuestosMF -sumImpuestosMF)
       if(Math.abs(difImpuestosMF) > 0) {
        toast.current?.show({
            life: 8000,
            severity: "warn",
            summary: "Message",
            detail:MESSAGE_DIFERENCIA_IMPUESTOS_MF + ' $' + Math.abs(difImpuestosMF)
          });
          return;
      }
    }

    if(presentacionComercio.impuestos_manual && userSessionModulo && isCombustibleAfines(selectedProductoComercio.grupoProductoId)){
      let impuestosNoDeclarados = dataImpuestos.impuestos.filter((item:any) => item.declarado == 0) 
      if(impuestosNoDeclarados.length > 0) {
          toast.current?.show({
              life: 8000,
              severity: "warn",
              summary: "Message",
              detail:MESSAGE_VALIDACION_IMPUESTOS
            });
            return
      }
    }

    let comprobantesList = undefined;
    if (comprobantes.length === 0 || comprobantes == undefined) {
      let resultComprobantes = await consultarFacturasPresentacion(
        presentacion
      );
      if (
        resultComprobantes.status == 200
      ) {
        comprobantesList = resultComprobantes.data.facturasIngresada;
        setComprobantes(resultComprobantes.data.facturasIngresada);
      }
    } else {
      comprobantesList = comprobantes;
    }

    let {
      diferenciaTotalVsComposicion,
      sumComprobantesTotales,
      sumatoriaDeImpuestos,
      sumTotalSinPercepciones,
      sumIVAperc, sumIIBBperc
      } = validacionesPresentacion(comprobantesList);

      if (sumIVAperc < 0) {
          toast.current?.show({
              life: 8000,
              severity: "warn",
              summary: "Message",
              detail:
                  "Existe un saldo negativo (-) en Percepciones de IVA. Recuerde que lo percibido debe ser mayor o igual que las percepciones descontadas con NC",
          });
          return;
      }

      if (sumIIBBperc < 0) {
          toast.current?.show({
              life: 8000,
              severity: "warn",
              summary: "Message",
              detail:
                  "Existe un saldo negativo (-) en Percepciones de IIBB. Recuerde que lo percibido debe ser mayor o igual que las percepciones descontadas con NC",
          });
          return;
      }

    if(isCombustibleAfines(selectedProductoComercio.grupoProductoId)){
      //25- TolImpEntreServiciosyFacturas
      let sumatoriaDeTasas = dataImpuestos.totalGeneral
        ? dataImpuestos.totalGeneral
        : 0;
      let diferenciaImpuestosFacturayTasasImpuestos = Number(sumatoriaDeImpuestos - sumatoriaDeTasas);
      
      let toleranciaServicioFacturas =  parametrosPresentacion.filter((item:ParametroDTO) => item.subcodigo == "TolImpEntreServiciosyFacturas")
      const TOLERANCIA_SERVICIO_FACTURA = Number.isNaN(Number.parseFloat(toleranciaServicioFacturas[0].valor)) ? 0 : parseFloat(toleranciaServicioFacturas[0].valor)

      if(presentacionComercio.impuestos_manual ){
          //validacion itc manual
        if (Math.abs(diferenciaImpuestosFacturayTasasImpuestos) > TOLERANCIA_SERVICIO_FACTURA) {
          toast.current?.show({
            life: 8000,
            severity: "warn",
            summary: "Message",
            detail:
              "La diferencia entre la suma total de impuestos y la suma total de ITCs supera la tolerancia permitida de: $" +
              formatMoney(TOLERANCIA_SERVICIO_FACTURA),
          });
    
          return;
        }

      }else{
        //itc automatico.Solo se valida que el impuesto del comprobante sea mayor al total de ITC.
        if (Number(sumatoriaDeImpuestos) < Number(sumatoriaDeTasas.toFixed(2))) {
          toast.current?.show({
            life: 8000,
            severity: "warn",
            summary: "Message",
            detail:
              "La diferencia entre la suma total de impuestos y la suma total de ITCs supera la tolerancia permitida"
          });
    
          return;
        }

      }
      
    }
      // 24- ToleranciaTotalVsComposicion $1
      let TolTotalVsComposicion =  parametrosPresentacion.filter((item:ParametroDTO) => item.subcodigo == "ToleranciaTotalVsComposicion")
      const TOLERANCIA_TOTAL_VS_COMPOSICION = Number.isNaN(Number.parseFloat(TolTotalVsComposicion[0].valor)) ? 0 : parseFloat(TolTotalVsComposicion[0].valor)
      
      if (Math.abs(diferenciaTotalVsComposicion) > TOLERANCIA_TOTAL_VS_COMPOSICION) {
        //Valida Si la suma de la composicion es igual al total mas/menos la tolerancia,
        toast.current?.show({
          life: 8000,
          severity: "warn",
          summary: "Message",
          detail:
            "La diferencia entre la suma de totales y el total de composicion de facturas supera la tolerancia permitida de: $" +
            formatMoney(TOLERANCIA_TOTAL_VS_COMPOSICION),
        });
        return;
      }
      //16- validar ToleranciaCargaFCyTRX $5
      //"La diferencia entre Transaciones y facturas está fuera de los valores soportados"
      let tolCargaFCyTRX =  parametrosPresentacion.filter((item:ParametroDTO) => item.subcodigo == "ToleranciaCargaFCyTRX")
      const TOLERANCIA_CARGAFC_Y_TRX = Number.isNaN(Number.parseFloat(tolCargaFCyTRX[0].valor)) ? 0 : parseFloat(tolCargaFCyTRX[0].valor)
      
      let diferenciaTotalTxSeleccionadasTotalComprobantes = Number(sumTSeleccionadas - sumTotalSinPercepciones);
      if (Math.abs(diferenciaTotalTxSeleccionadasTotalComprobantes) > TOLERANCIA_CARGAFC_Y_TRX) {
        toast.current?.show({
          life: 8000,
          severity: "warn",
          summary: "Message",
          detail:
            "La diferencia entre el total Facturado y el total de las Transacciones supera la tolerancia permitida de: $" +
            formatMoney(TOLERANCIA_CARGAFC_Y_TRX),
        });
        return;
      }

    setShowDialogPresentar(true);
  };

  const onHide = () => {
    setShowDialogAnular(false);
  };
  const anularComprobante = async () => {
    setShowMask(true);
    const resultAnularPresentacion = await anularPresentacion(presentacion);
    if (resultAnularPresentacion.status === 200) {
      toast.current?.show({
        life: 6000,
        severity: "success",
        summary: "Message",
        detail: MESSAGE_SUCCESS_ANULAR_PRESENTACCION,
      });
      setShowMask(false);
      setShowDialogAnular(false);
      history.push({ pathname: PrivateRoutes.PRESENTACIONES, search: "" });
    } else {
      toast.current?.show({
        life: 6000,
        severity: "warn",
        summary: "Message",
        detail: MESSAGE_FAILED_ANULAR_PRESENTACCION,
      });
      setShowDialogAnular(false);
      setShowMask(false);
    }
    
  };

  const onClickPresentarPresentacion = async () => {
    setSpinnerPresentacion(true)
    let presentacionGenerada = presentacionPresentarRequest();
    presentacionGenerada.preCupon = presentacion;
    presentacionGenerada.idComercio = comercioSelecionado[0].comercioId;

    const { sumComprobantesTotales } = comprobantesProcess(comprobantes);

    presentacionGenerada.totalOnLine = sumComprobantesTotales;
    const resultPresentacion = await presentarPresentacion(
      presentacionGenerada
    );
    if (resultPresentacion.status === 200) {
      console.log(resultPresentacion)

      downloadFile(resultPresentacion.data.presentacionDocumento, resultPresentacion.data.nombrePDF)
      if(state){
        let presentacion = JSON.parse(state);
        history.push({pathname:PrivateRoutes.CARGAR_PRESENTACION,search:`?presentacion=${presentacion.pre_cupon}`,state:`${ state }`})
      }else{
        history.push({pathname:PrivateRoutes.CARGAR_PRESENTACION,search:`?presentacion=${presentacionComercio.pre_cupon}`,state:`${ JSON.stringify(presentacionComercio) }`})
      }

      toast.current?.show({
        life: 8000,
        severity: "success",
        summary: "Message",
        detail: "Presentación creada correctamente.",
      });

      setShowDialogPresentar(false);
      setShowMask(true);
      setTimeout(() => {
        location.reload();
      }, 5000);
    } else {
      toast.current?.show({
        life: 8000,
        severity: "error",
        summary: "Message",
        detail: MESSAGE_ERROR_PRESENTACION,
      });
    }
    setSpinnerPresentacion(false)
  };

  const downloadFile = (b64: any, fileName: string) => {
    const pdfLink = `data:application/pdf;base64,${b64}`;
    const anchorElement = document.createElement('a');
    const fileNames = `${fileName}.pdf`;
    anchorElement.href = pdfLink;
    anchorElement.download = fileNames;
    anchorElement.click();
  };

  const renderFooterAnular = () => {
    return (
      <div className="p-grid p-justify-between p-align-center">
        <div className="p-col-12" style={{ textAlign: "center" }}>
          <div className="table-header-container">
            <div className="button-demo">
              <div className="template">
                <Button
                  type="button"
                  className="delete p-0"
                  aria-label="Discord"
                  onClick={onHide}
                  style={{ minWidth: "100px" }}
                >
                  <i className="pi pi-times px-2"></i>
                  <span className="px-3">No</span>
                </Button>
                <Button
                  className="twitter p-0"
                  aria-label="Twitter"
                  onClick={anularComprobante}
                  style={{ minWidth: "100px" }}
                >
                  <i className="pi pi-check  px-2"></i>
                  <span className="px-3">Si</span>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderFooter = () => {
    return (
      <div className="p-grid p-justify-between p-align-center">
        <div className="p-col-12" style={{ textAlign: "center" }}>
          <div className="table-header-container">
            <div className="button-demo">
              <div className="template">
                <Button
                  type="button"
                  className="delete p-0"
                  aria-label="Discord"
                  onClick={() => setShowDialogPresentar(false)}
                  style={{ minWidth: "150px" }}
                >
                  <i className="pi pi-times px-2"></i>
                  <span className="px-3">Cancelar</span>
                </Button>
                <Button
                  className="twitter p-0"
                  aria-label="Twitter"
                  onClick={onClickPresentarPresentacion}
                  style={{ minWidth: "150px" }}
                >
                  
                  {spinnerPresentacion ? <div style={{width: "38px", backgroundColor: "#3b82f6"}}><i className="pi pi-spin pi-spinner"></i></div> :<i className="pi pi-plus px-2" ></i>}
                  <span className="px-3">Confirmar</span>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <Toast ref={toast} position="bottom-right" />
      {showDialogAnular && (
        <Dialog
          header="Anular Comprobante"
          visible={showDialogAnular}
          style={{ width: "30vw" }}
          footer={renderFooterAnular}
          onHide={onHide}
        >
          <span
            style={
              {
                /*fontWeight: "500", fontSize: "18px"*/
              }
            }
          >
            ¿Estás seguro de anular esta presentación?
          </span>
        </Dialog>
      )}
      {showDialogPresentar && (
        <div className="dialog-demo">
          <div className="card">
            <Dialog
              header="Confirmar Presentación"
              visible={showDialogPresentar}
              className="eden-dialog-presentation"
              
              footer={isCombustibleAfines(selectedProductoComercio.grupoProductoId)
                ? (detailsTxSeleccionadas.length) > 0 && renderFooter 
                : renderFooter }
              onHide={() => setShowDialogPresentar(false)}
            >
              <ComprobantesDialogDetalle />
            </Dialog>
          </div>
        </div>
      )}
      {(transaccionesSeleccionadas.length > 0 || sumTSeleccionadas > 0) && presentacionEditable && (
        <Card>
          <div className="p-grid p-justify-between p-align-center">
            <div className="p-col-12" style={{ textAlign: "center" }}>
              <div className="button-demo">
                <div className="template">
                  <Button
                    type="button"
                    className="delete p-0"
                    aria-label="Discord"
                    onClick={() => setShowDialogAnular(true)}
                    style={{ minWidth: "150px" }}
                  >
                    <i className="pi pi-times px-2"></i>
                    <span className="px-3">Anular</span>
                  </Button>
                  <Button
                    className="twitter p-0"
                    aria-label="Twitter"
                    onClick={onClickPresentar}
                    style={{ minWidth: "150px" }}
                  >
                    <i className="pi pi-plus px-2"></i>
                    <span className="px-3">Presentar</span>
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </Card>
      )}
    </>
  );
};

export default AccionesPresentaciones;
